import { CACHE_KEY_PREFIX as AUTH0_CACHE_KEY_PREFIX } from './constants';
export class LocalStorageCache {
    constructor(namespacePrefix) {
        this.namespacePrefix = namespacePrefix;
    }
    set(key, entry) {
        key = this.modifyKeyPrefix(key);
        localStorage.setItem(key, JSON.stringify(entry));
    }
    get(key) {
        key = this.modifyKeyPrefix(key);
        const json = window.localStorage.getItem(key);
        if (!json)
            return;
        try {
            const payload = JSON.parse(json);
            return payload;
        }
        catch (e) {
            return;
        }
    }
    remove(key) {
        key = this.modifyKeyPrefix(key);
        localStorage.removeItem(key);
    }
    allKeys() {
        return Object.keys(window.localStorage).filter(key => key.startsWith(this.namespacePrefix));
    }
    modifyKeyPrefix(key) {
        if (!key)
            return key;
        return key.replace(AUTH0_CACHE_KEY_PREFIX, this.namespacePrefix);
    }
}
//# sourceMappingURL=LocalStorageCache.js.map